module.exports = ".form-group .col-md-2.txt{\r\n    padding-top: 20px;\r\n}"